import { EnumModuleType } from '@/src/types/common/module';
import { get } from 'lodash';
import CarouselStrategy from './Carousel';
import GridStrategy from './Grid';
import IframeStrategy from './Iframe';
import PosterStrategy from './Poster';
import SubscriptionStrategy from './Subscription';
import TabStrategy from './Tab';
import TextStrategy from './Text';

type Args = {
  changedFields: Array<any>;
  pc: any;
  tablet: any;
  mobile: any;
};

const copyStrategy = (args: any) => {
  const moduleType = get(args, 'pc.moduleType');
  switch (moduleType) {
    case EnumModuleType.ResponsiveContentCarousel: {
      return CarouselStrategy.copyStrategy(args);
    }
    case EnumModuleType.ResponsiveImageCarousel: {
      return CarouselStrategy.copyStrategy(args);
    }
    case EnumModuleType.ResponsiveProductCarousel: {
      return CarouselStrategy.copyStrategy(args);
    }
    case EnumModuleType.ResponsiveProductGrid: {
      return GridStrategy.copyStrategy(args);
    }
    case EnumModuleType.ResponsiveContentGrid: {
      return GridStrategy.copyStrategy(args);
    }
    case EnumModuleType.ResponsiveSubscription: {
      return SubscriptionStrategy.copyStrategy(args);
    }
    case EnumModuleType.ResponsivePoster: {
      return PosterStrategy.copyStrategy(args);
    }
    default: {
      return args.pc;
    }
  }
};

const invokeStrategy = (args: Args) => {
  const moduleType = get(args, 'pc.moduleType');

  switch (moduleType) {
    case EnumModuleType.ResponsiveContentCarousel: {
      return CarouselStrategy.invokeStrategy({
        ...args,
        moduleType: moduleType,
      });
    }
    case EnumModuleType.ResponsiveImageCarousel: {
      return CarouselStrategy.invokeStrategy({
        ...args,
        moduleType: moduleType,
      });
    }
    case EnumModuleType.ResponsiveProductCarousel: {
      return CarouselStrategy.invokeStrategy({
        ...args,
        moduleType: moduleType,
      });
    }
    case EnumModuleType.ResponsiveContentGrid: {
      return GridStrategy.invokeStrategy({
        ...args,
        moduleType: moduleType,
      });
    }
    case EnumModuleType.ResponsiveProductGrid: {
      return GridStrategy.invokeStrategy({
        ...args,
        moduleType: moduleType,
      });
    }
    case EnumModuleType.ResponsiveText: {
      return TextStrategy.invokeStrategy({
        ...args,
        moduleType: moduleType,
      });
    }
    case EnumModuleType.ResponsiveSubscription: {
      return SubscriptionStrategy.invokeStrategy({
        ...args,
        moduleType: moduleType,
      });
    }
    case EnumModuleType.ResponsivePoster: {
      return PosterStrategy.invokeStrategy({
        ...args,
        moduleType: moduleType,
      });
    }
    case EnumModuleType.ResponsiveContentTab: {
      return TabStrategy.invokeStrategy({
        ...args,
        moduleType: moduleType,
      });
    }
    case EnumModuleType.ResponsivePosterTab: {
      return TabStrategy.invokeStrategy({
        ...args,
        moduleType: moduleType,
      });
    }
    case EnumModuleType.ResponsiveProductTab: {
      return TabStrategy.invokeStrategy({
        ...args,
        moduleType: moduleType,
      });
    }
    case EnumModuleType.ResponsiveIframe: {
      return IframeStrategy.invokeStrategy({
        ...args,
        moduleType: moduleType,
      });
    }
    default:
      return;
  }
};
export default invokeStrategy;
export { copyStrategy };
